/**
 * Created by Jie Gao on 2017-05-22.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WixxGameConfig} from "../WixxGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite, Power0} from "gsap";

export class LogoOnBackground extends BaseView {

    private _layer:PIXI.Container;
    private _timeline:TimelineLite;
    private _isNextRespin:boolean;
    private _isRespin:boolean;

    constructor() {
        super();
        this._layer = StageManager.getLayer(WixxGameConfig.instance.LAYERS.LOGO_ON_BACKGROUND.name);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.onSpinStart());

        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STARTED, (event:GameEvent) => this.onAllReelStarted());
        EventHandler.addEventListener(this, ReelEvent.REEL_STOP_SPIN_STARTED, (event:GameEvent) => this.onAllReelStartStop(event.params[0]));
    }

    private onGameDataParsed(data:ParsedServerData):void {
        this._isNextRespin = data.nextMode === GameMode.RESPIN;
    }

    private onSpinStart():void {
        this._isRespin = this._isNextRespin;
    }

    protected initAnimations():void {
        const sprite = new PIXI.Sprite(GameResources.getTextures("logo_on_background")[0]);
        sprite.x = 343 + 72;
        sprite.y = 232 - 12;
        sprite.blendMode = PIXI.BLEND_MODES.ADD;
        sprite.anchor.set(0, 0);
        sprite.alpha = 0;
        this._layer.addChild(sprite);

        this._timeline = new TimelineLite({paused : true});
        this._timeline.add(TweenLite.to(sprite, 0.5, {alpha : 1, ease : Power0.easeIn}));
    }

    private onAllReelStarted():void {
        if(this._isRespin) {
            return;
        }

        this._timeline.play();
    }

    private onAllReelStartStop(reelId:number):void {
        if(reelId === 0) {
            this._timeline.reverse();
        }
    }
}